<template>
	<button
		v-if="ticket && (ticket.support_ticket_status == 10 || ticket.support_ticket_status == 20)"
		type="button"
		class="relative -ml-px hidden items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:z-10 hover:bg-gray-50 focus:z-10 sm:inline-flex"
		@click="handleClose">
		<i class="fa fa-check text-gray-600 mr-1"></i>
		Concluir
	</button>
</template>

<script>
import LoadingMixin from "@/mixins/loading_emitter.js"
import SupportTickets from "@/API/backoffice/Tickets.js"

export default {
	name: "SupportTicketCloseButton",
	mixins: [LoadingMixin],
	props: {
		ticket: {
			type: Object,
			required: true
		}
	},
	methods: {
		/**
		 * Handle close
		 * @returns {Promise<boolean>}
		 */
		async handleClose() {
			console.debug("SupportTicketCloseButton@handleClose: Closing SupportTicket.", {id: this.ticket.id})

			this.loading()
			const [err, res] = await SupportTickets.close(this.ticket.id)
			this.loaded()

			if (err) {
				console.error("SupportTicketCloseButton@handleClose: Error on close SupportTicket.", err)
				return false
			}

			this.ticket = res.data.data

			console.info("SupportTicketCloseButton@handleClose: SupportTicket closed.", {id: this.ticket.id})

			this.$emit('closed')
			return true
		}
	}
}
</script>